<div class="settings-container">
  @if (zoom) {
    <rask-header size="3">
      <rask-action-button (click)="toggleContentPanel()" icon="fal fa-cog">
        {{texts.installningar}}
      </rask-action-button>
    </rask-header>
  }
  @if (visible) {
    <div class="container m-0 settings-content">
      <div clas="row">
        <rask-slider
          class="col-12"
          [label]="texts.zoom"
          [ngModel]="zoom"
          (change)="zoomChanged($event)"
          [min]="minZoom"
          [max]="maxZoom"
          [step]="1">
        </rask-slider>
      </div>
      <div clas="row">
        <rask-datepicker
          [appendToBody]="false"
          class="col-6"
          [ngModel]="viewDate"
          (change)="viewDateChanged($event)"
          [label]="texts.betraktelsedatum">
        </rask-datepicker>
      </div>
      <div class="row button-row">
        <div class="col mx-0 px-0 d-flex justify-content-center">
          <rask-button class="mx-0 mt-3 px-0" color="secondary" (click)="setToday()">{{texts.idag}}</rask-button>
        </div>
        <div class="col mx-0 px-0 d-flex justify-content-center">
          <rask-button class="mx-0 mt-3 px-0" color="secondary" (click)="setNextMonth()">{{texts.nastaManad}}</rask-button>
        </div>
      </div>
      <div class="row link-row">
        <div class="col mx-0 px-0 d-flex justify-content-center">
          <rask-button class="mx-0 mt-3 px-0" color="tertiary" (click)="openMinaMaskinlag()">{{texts.hanteraMaskinlag}}</rask-button>
        </div>
        <div class="col mx-0 px-0 d-flex justify-content-center">
          @if (currentArbetsorder) {
            <rask-button class="mx-0 mt-3 px-0" color="tertiary" (click)="moveToArbetsorder()">Visa arbetsorder</rask-button>
          }
        </div>
      </div>
    </div>
  }
</div>